import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useMountEffect } from "@react-hookz/web";
import type { EditorState } from "lexical";
import type { FC } from "react";

export const EditorInitializationPlugin: FC<{ onChange: (state: EditorState) => void }> = ({
  onChange,
}) => {
  const [editor] = useLexicalComposerContext();

  useMountEffect(() => {
    const timeoutId = setTimeout(() => {
      const editorState = editor.getEditorState();
      onChange(editorState);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
    };
  });

  return null;
};
